import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import axios from 'axios'

Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/appDashboard',
            props: true,
            name: 'AdminDashboard',
            component: () =>
                import ('./components/Common/appDashboard'),
            meta: {
                requiresAuth: true,
                isAdmin: true,
                isSuperAdmin: false,
            },
            children: [{
                    path: '/studentList',
                    name: 'Student List',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Students/studentList')
                },
                {
                    path: '/studentDetails/:id',
                    name: 'Student Details',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Students/studentDetails')
                },
                {
                    path: '/viewAttendance',
                    name: 'View Attendance',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Students/viewAttendance')
                },
                {
                    path: '/addStudent',
                    name: 'Add Student',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Students/addStudent')
                },
                {
                    path: '/viewStudent',
                    name: 'View Student',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Students/viewStudent')
                },
                {
                    path: '/staffList',
                    name: 'Staff List',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Staff/staffList')
                },
                {
                    path: '/staffDetails/:id',
                    name: 'Staff Details',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Staff/staffDetails')
                },
                {
                    path: '/addStaff',
                    name: 'Add Staff',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Staff/addStaff')
                },
                {
                    path: '/addClass',
                    name: 'Add Class',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Class/addClass')
                },
                {
                    path: '/addClassTeacher',
                    name: 'Add Class Teacher',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Class/addClassTeacher')
                },
                {
                    path: '/viewClass/:id',
                    name: 'View Class',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Class/viewClass')
                },
                {
                    path: '/noticeboard2',
                    name: 'noticeboard2',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Noticeboard2/noticeboard2')
                },
                {
                    path: '/noticeEdit',
                    name: 'noticeEdit',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Noticeboard2/noticeEdit')
                },
                {
                    path: '/noticeview',
                    name: 'noticeview',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Noticeboard2/noticeView')
                },
                {
                    path: '/analytics',
                    name: 'Analytics',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Analytics/analytics')
                },
                {
                    path: '/noticeadd',
                    name: 'noticeadd',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Noticeboard2/noticeAdd')
                },
                {
                    path: '/addexam',
                    name: 'addexam',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Exam/addExam')
                },
                {
                    path: '/viewExam',
                    name: 'viewExam',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Exam/viewExam')
                },
                {
                    path: '/addSubject',
                    name: 'addSubject',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Subject/addSubject')
                },
                {
                    path: '/viewSubject',
                    name: 'viewSubject',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Subject/viewSubject')
                },
                {
                    path: '/topperVideo',
                    name: 'Topper Video',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/TopperVideo/topperVideo')
                },
                {
                    path: '/topperVideoDetails/:id',
                    name: 'Topper Video Details',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/TopperVideo/topperVideoDetails')
                },
                {
                    path: '/viewMoreAttendence',
                    name: 'View More',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Attendence/viewMoreAttendence')
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/Admin/profile')
                },


            ]
        },
        {
            path: '/SuperadminDashboard',
            props: true,
            name: 'SuperadminDashboard',
            component: () =>
                import ('./components/Common/SuperadminDashboard'),
            meta: {
                requiresAuth: true,
                isAdmin: true,
                isSuperAdmin: false,
            },
            children: [{
                    path: '/schoolAdd',
                    name: 'School Add',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/SuperAdmin/School/schoolAdd')
                }, {
                    path: '/schoolList',
                    name: 'School List',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/SuperAdmin/School/schoolList')
                }, {
                    path: '/schoolView',
                    name: 'School View',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/SuperAdmin/School/schoolView')
                }, {
                    path: '/adminAdd',
                    name: 'Admin Add',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/SuperAdmin/Admin/adminAdd')
                },
                {
                    path: '/adminList',
                    name: 'Admin List',
                    meta: {
                        requiresAuth: true,
                        isAdmin: true,
                        isSuperAdmin: false,
                    },
                    component: () =>
                        import ('./components/SuperAdmin/Admin/adminList')
                },
            ]

        },
        {
            path: '/',
            name: 'Login',
            props: true,
            meta: {
                requiresAuth: false,
                isAdmin: true,
                isSuperAdmin: true,
            },
            component: () =>
                import ('./components/Login/adminLogin'),
        },
        {
            path: '/login3',
            name: 'Login Verify',
            props: true,
            meta: {
                requiresAuth: true,
                isAdmin: true,
                isSuperAdmin: true,
            },
            component: () =>
                import ('./components/Login/login3'),
        },
        // {
        //     path: '/ServerError',
        //     name: 'ServerError',
        //     props: true,
        //     component: () =>
        //         import ('./components/Common/500'),
        // },
        {
            path: '*',
            name: '404PageNotFound',
            props: true,
            meta: {
                requiresAuth: false,
                isAdmin: true,
                isSuperAdmin: true,
            },
            component: () =>
                import ('./components/Common/404'),
        },
    ]
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresAuth && store.state.isLoggedIn == false)) {
        next({
            name: 'Login',
            params: { lastPage: from }
        })
        return
    }
    if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
        axios({
                method: 'POST',
                url: '/validate/token',
                headers: {
                    'x-auth-token': localStorage.getItem('token')
                }
            }).then(response => {
                if (!response.data.status) {
                    store.commit("sessionOut", true)
                    return
                }
            })
            .catch(err => {
                var msg = err;
                console.log(msg)
            });
    }
    if ((to.name == 'Login') && store.state.isLoggedIn == true && (store.state.userType == 'Admin')) {
        next({ name: 'AdminDashboard' })
        return
    }
    if ((to.name == 'Login') && store.state.isLoggedIn == true && (store.state.userType == 'SuperAdmin')) {
        next({ name: 'SuperadminDashboard' })
        return
    }
    if (to.matched.some(route => route.meta.isAdmin == false) && store.state.isLoggedIn == true && (store.state.userType == 'Admin')) {
        next({ name: 'AdminDashboard' })
        return
    }
    if (to.matched.some(route => route.meta.isSuperAdmin == false) && store.state.isLoggedIn == true && (store.state.userType == 'SuperAdmin')) {
        next({ name: 'SuperadminDashboard' })
        return
    }
    next()
})
export default router